import { all } from "redux-saga/effects";

import { watchAcceptInvite } from "./acceptInvite";
import { watchCreateAccount } from "./createAccount";

export function* rootSaga() {
  yield all([watchAcceptInvite(), watchCreateAccount()]);
}
